//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import master_menu from '../library/master_menu';
 
import MASTER_MENU from  '../library/master_menu'

export default {
      

    data() {
        return {
            token : localStorage.token,   
            pekerjaan:'',
            pekerjaan_lainnya:'',
            agama:'',
            agama_lainnya:'',
            pendidikan:'',
            pendidikan_lainnya:'',

            shdk:'',
            shdk_lainnya:'',




            dta_slct: [{nama:'nama1', code:'25'}, {nama:'nama2', code:'26'}, {nama:'nama3', code:'27'}],
                        
            nama:'',
            pekerjaan:'', 
            form:{
              agama:'',
              kd_agama:'',
              agama_lainnya:'',
              },

            listAgama :{
              uraian:''
            },
            MASTER_MENU:MASTER_MENU, 

        }
    },

    methods: {
    masukan: function (){
      alert("Semua data Dimasukan =" + this.nama + "# " + this.pekerjaan); 
    },      

    renderChildProv(data) {
        return `
        <span><b>${data.kd_agama}</b></span>
        <span style='font-size:80%'>${data.uraian}</span>
        `
    },
    prov_ayah(data){ 
      this.form.agama = data.id  
      this.form.kd_agama = data.kd_agama  
    },

    selectData:function(data){
      this.listAgama = {
          uraian : data.m_provinsi.uraian,
          kd_agama : data.m_provinsi.kd_provinsi, 
      }

    },
    },
    mounted() {
      this.MASTER_MENU.pekerjaan()
      this.MASTER_MENU.agama()
      this.MASTER_MENU.pendidikan()
      this.MASTER_MENU.shdk()
    },

}

